var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentFilled = function SvgDocumentFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2a2 2 0 0 0-2 2v15.75a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H6Zm7.408 12.645a.5.5 0 0 0 0-1H8.285a.5.5 0 1 0 0 1h5.123Zm-5.123-3.637h7.623a.5.5 0 0 0 0-1H8.285a.5.5 0 1 0 0 1Zm-.5-4.137a.5.5 0 0 1 .5-.5h7.623a.5.5 0 0 1 0 1H8.285a.5.5 0 0 1-.5-.5Z",
    fill: "#000"
  })));
};
export default SvgDocumentFilled;